import React from 'react';
import { Link } from 'react-router-dom';
import { Card } from '../../components/ui/Card';
const completedCourses = [{
  name: 'Ethics & The Rules (with NAR Code of Ethics)',
  creditType: '3 hrs. Comm. Standards',
  dateCompleted: '02/12/2025'
}];
export function ClassHistory() {
  return <div className="space-y-4" data-id="element-1899">
      {/* Inserted a styled header section with background color, heading, and description */}
      <div className="rounded-xl px-6 py-5 text-white" style={{
      backgroundColor: '#4A2D8F'
    }} data-id="element-1900">
        <h1 className="text-2xl font-extrabold tracking-tight mb-1" data-id="element-1901">
          Class History
        </h1>
        <p className="text-purple-200 text-sm" data-id="element-1902">
          View your completed courses and download certificates to save or
          print.
        </p>
      </div>

      <div data-id="element-1903">
        <button className="text-blue-600 hover:underline text-sm font-medium uppercase tracking-wide" data-id="element-1904">
          CE CREDITS TRACKER
        </button>
        <span className="ml-1 inline-flex items-center justify-center w-4 h-4 rounded-full bg-blue-500 text-white text-xs font-bold" data-id="element-1905">
          ?
        </span>
      </div>

      <p className="text-xs text-slate-600" data-id="element-1906">
        *You will need Adobe Reader installed on your computer to print the
        certificate.{' '}
        <button className="text-blue-600 hover:underline" data-id="element-1907">Click here</button> to
        download the free reader.*
      </p>

      <Card className="overflow-hidden rounded-none border-slate-300" data-id="element-1908">
        <div className="overflow-x-auto" data-id="element-1909">
          <table className="w-full text-sm text-left" data-id="element-1910">
            <thead style={{
            backgroundColor: '#4A2D8F'
          }} className="text-white font-medium" data-id="element-1911">
              <tr data-id="element-1912">
                <th className="px-4 py-3 border-r border-purple-700" data-id="element-1913">Class</th>
                <th className="px-4 py-3 border-r border-purple-700 w-40 text-center" data-id="element-1914">
                  Credit Type
                </th>
                <th className="px-4 py-3 border-r border-purple-700 w-32 text-center" data-id="element-1915">
                  Date Completed
                </th>
                <th className="px-4 py-3 border-r border-purple-700 w-28 text-center" data-id="element-1916">
                  Print Certificate
                </th>
                <th className="px-4 py-3 w-28 text-center" data-id="element-1917">Review Class</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-200" data-id="element-1918">
              {completedCourses.map((course, i) => <tr key={i} className="hover:bg-purple-50/20" data-id="element-1919">
                  <td className="px-4 py-2.5 border-r border-slate-200 text-slate-800" data-id="element-1920">
                    {course.name}
                  </td>
                  <td className="px-4 py-2.5 border-r border-slate-200 text-center text-slate-700" data-id="element-1921">
                    {course.creditType}
                  </td>
                  <td className="px-4 py-2.5 border-r border-slate-200 text-center text-slate-700" data-id="element-1922">
                    {course.dateCompleted}
                  </td>
                  <td className="px-4 py-2.5 border-r border-slate-200 text-center" data-id="element-1923">
                    <button className="text-blue-600 hover:underline text-sm" data-id="element-1924">
                      Print Certificate
                    </button>
                  </td>
                  <td className="px-4 py-2.5 text-center" data-id="element-1925">
                    <Link to={`/student/class/${course.name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '')}/content`} className="text-blue-600 hover:underline text-sm" data-id="element-1926">
                      Review Class
                    </Link>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </Card>
    </div>;
}